import { obtenirUrlControleur } from '../utils/urlUtils';
import fetch, { jsonHeaders } from '../utils/fetch';
import FormationSanitaire from '../modeles/FormationSanitaire';
import { FormationSanitaireDto } from '../modeles/FormationSanitaireDto';
import { ReponseFormationSanitaireDto } from '../modeles/ReponseFormationSanitaireDto';

const lienFormationSanitaire = obtenirUrlControleur('formation-sanitaire');
const routeFormationSanitaire = `${lienFormationSanitaire}/api/FormationSanitaire`;

const mapperFormation = (formation: ReponseFormationSanitaireDto) => new FormationSanitaire({
    id: formation.id,
    nom: formation.nom,
    districtId: formation.idDistrict
});

export default class FormationSanitaireApi {
    static async obtenirToutesLesFormationsSanitaires(): Promise<FormationSanitaire[]> {
        const formations = await fetch(`${routeFormationSanitaire}/formationssanitaires`, { method: 'GET' }) as ReponseFormationSanitaireDto[];
        return Array.isArray(formations) ? formations.map(mapperFormation) : [];
    }

    static async obtenirFormationsSanitaires(districtId: string): Promise<FormationSanitaire[]> {
        if (!districtId) return [];
        const formations = await fetch(`${routeFormationSanitaire}/district/${districtId}/formationssanitaires`, { method: 'GET' }) as ReponseFormationSanitaireDto[];
        return Array.isArray(formations) ? formations.map(mapperFormation) : [];
    }

    static async obtenirFormationSanitaireParId(id: string): Promise<FormationSanitaire | null> {
        if (!id) return null;
        const formation = await fetch(`${routeFormationSanitaire}/formationsanitaire/${id}`, { method: 'GET' }) as ReponseFormationSanitaireDto;
        return formation ? mapperFormation(formation) : null;
    }

    static async ajouterFormationSanitaire(dto: FormationSanitaireDto): Promise<void> {
        await fetch(`${routeFormationSanitaire}/ajouter`, {
            method: 'POST',
            headers: jsonHeaders,
            body: JSON.stringify(dto)
        });
    }

    static async modifierFormationSanitaire(dto: FormationSanitaireDto): Promise<void> {
        await fetch(`${routeFormationSanitaire}/formationsanitaire`, {
            method: 'PUT',
            headers: jsonHeaders,
            body: JSON.stringify(dto)
        });
    }

    static async supprimerFormationSanitaire(id: string): Promise<void> {
        await fetch(`${routeFormationSanitaire}/formationsanitaire/${id}`, {
            method: 'DELETE',
            headers: jsonHeaders,
        });
    }
}